var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('question-template',{attrs:{"name":"isIncomeOver","showTutorials":_vm.showTutorials,"description":"(ประมาณ 150,000 บาท/เดือน หรือ 5,000 บาท/วัน)"}}),_c('tutorial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }